import { MarketRelation } from 'types/indexer'

export interface LatestListQuery {
  markets?: MarketRelation[]
  // eslint-disable-next-line camelcase
  markets_aggregate: {
    aggregate: {
      count: number
    }
  }
}

export interface LatestStoresQuery {
  store: {
    name: string
    id: string
    headerImage?: string
  }[]
}

export interface ActiveStoresQuery {
  // eslint-disable-next-line camelcase
  top_stores: {
    store: {
      name: string
      id: string
    }
    headerImage?: string
  }[]
}

export interface ActiveAuctions {
  markets?: MarketRelation[]
  // eslint-disable-next-line camelcase
  markets_aggregate: {
    aggregate: {
      count: number
    }
  }
}

export enum FilterOptions {
  NEWEST = 'newest',
  OLDEST = 'oldest',
  CHEAPEST = 'cheapest',
  EXPENSIVE = 'most-expensive',
}

export type MarketTabProps = {
  filter: FilterOptions
  page?: number
}

export type TMarketTab = {
  title: string
  component: (props: MarketTabProps) => JSX.Element | null
  active: boolean
  filterOptions: {
    label: string
    defaultOptionId: FilterOptions
    options:
      | {
          id: FilterOptions
          label: string
        }[]
      | null
  }
}

export type MarketplaceController = {
  itemsPerPage?: number
  initialPageIndex?: number
  filter?: FilterOptions
  initialSSRData?: MarketRelation[]
}
